import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToHash from "./ScrollToHash";
import { CartProvider } from "@/context/CartContext";
import CartDrawer from "./store/CartDrawer";

export default function Layout() {
  return (
    <CartProvider>
      <div className="App">
        <ScrollToHash />
        <a
          href="#main"
          className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-white focus:text-navy focus:px-3 focus:py-2 focus:rounded"
        >
          Skip to main content
        </a>
        <Header />
        <main id="main">
          <Outlet />
        </main>
        <Footer />
        <CartDrawer />
      </div>
    </CartProvider>
  );
}
